module.exports = __webpack_public_path__ + "twitter.501de59d635b133d4c08c60eff046ba1.svg";